
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TextArea extends Vue {
  @Prop({ type: Number, default: 10 }) min!: number
  @Prop({ type: Number, default: 500 }) max!: number
  @Prop({ type: String, default: '' }) placeholder: string
  @Prop({ type: String, default: '' }) value: string

  get message() {
    if (this.min && this.value.length <= this.min - 1) { return `Enter at least ${this.min} characters` }
    if (this.value.length > this.min - 1 && this.value.length < this.max) { return `${this.max - this.value.length} remaining` }
    if (this.value.length >= this.max) { return 'Maximum is reached' }
  }
}
